<template>
  <div class="rule-container">
    <van-nav-bar v-if="isLargeScreen === false && isInKwaiying()" title="活动规则" fixed left-arrow :border="false"
      @click-left="goBack" />
    <div class="content">
      <template v-if="isLargeScreen === true">
        <p class="title">活动规则</p>
        <VueLazyImg classStyle="act-img" style="max-width: 20rem;z-index: 99;"
          src="https://p4-ky.wsukwai.com/kos/nlav12119/VPccICAF_2024-08-15-15-58-24.png" />
        <img src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/bottomBG.png" class="bottom-mask" />
      </template>
      <template v-if="isLargeScreen === false">
        <div class="wrapper">
            <!-- 防止顶部遮挡 -->
           <div v-if="isInKwaiying()" style="height: 0.2rem; width: 100%; background-color: #000;"></div>
          <!-- 不使用懒加载是为了快速显示图片内容 -->
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/kos/nlav12119/lCWJYaIy_2024-08-07-20-21-42.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule2.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule3.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule4.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule5.png" />
          <VueLazyImg classStyles="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule6.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule7.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule8.png" />
          <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/rule9.png" />
        </div>
      </template>
    </div>
    <!-- 避免有的PC装了json序列化插件导致顶部展示序列化内容 -->
    <span style="display: none;">0</span>
  </div>
</template>
<script setup lang="ts">
import "vant/lib/index.css";
import { NavBar as VanNavBar } from "vant";
import useDevice from "~/components/kling/common/useDevice";
import useRem from "~/components/kling/common/useRem";
import isInKwaiying from '@ky/sdk/dist/isInKwaiying'
import close from "@ky/sdk/dist/close";
useRem();

// const { isLargeScreen } = useDevice();

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
useHead({
  title: "活动规则",
});
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})

const goBack = () => {
  if (isInKwaiying()) {
    close()
  } else {
    navigateTo(`/kling/contribution`);
  }
};
const onClickLeft = () => {
  navigateTo(`/kling/contribution`);
};

</script>

<style scoped lang="less">
.rule-container {
  width: 100vw;
  min-height: 100vh;
  background-color: #000;
  --van-nav-bar-height: 1.7rem;
  --van-nav-bar-arrow-size: 0.52rem;
  --van-nav-bar-title-text-color: #fff;
  --van-nav-bar-title-font-size: 0.35rem;
  --van-nav-bar-icon-color: #fff;
  --van-nav-bar-z-index: 999;

  :deep(.van-nav-bar__content) {
    height: 1.7rem;
    padding-top: 0.8rem;
    background-color: #000;
  }

  :deep(.van-nav-bar__left) {
    top: 0.8rem
  }

  .content {
    display: flex;
    flex-direction: column;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.4rem;
    font-weight: 500;
    line-height: 0.56rem;
    width: 100%;
    align-items: center;
    padding-top: 2rem;
    background-color: #000;

    @media screen and (max-width: 1360px) {
      padding-top: 0rem;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 2rem;
    width: 7.5rem;
    z-index: 2;
    @media screen and (max-width: 1360px) {
      padding-top: 0rem;
    }
  }

  .bottom-mask {
    position: sticky;
    width: 100%;
    height: 5rem;
    bottom: 0;
  }

  .title {
    font-size: 0.7rem;
    color: #FFF;
    margin-bottom: 1rem;

    @media screen and (max-width:1360px) {
      font-size: .32rem;
      margin-bottom: .38rem;
    }
  }

  .act-img {
    width: 6.86rem;
    z-index: 99;
  }
}
</style>
